import { render, staticRenderFns } from "./TutorDetails.vue?vue&type=template&id=58044010&scoped=true"
import script from "./TutorDetails.vue?vue&type=script&lang=js"
export * from "./TutorDetails.vue?vue&type=script&lang=js"
import style0 from "./TutorDetails.vue?vue&type=style&index=0&id=58044010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58044010",
  null
  
)

export default component.exports